import React, { FC } from 'react'
import { isToday, format, parseISO } from 'date-fns'
import CheckMark from '../../../assets/img/checkmark-active.png'
import CircleChatHistoryIcon from '../../../assets/img/circle-chat-history-icon.svg'

import './PostActionWrapper.scss'
import { ACTION_TYPE } from '../../../models/post'


export enum MARK_TYPE {
  TYPE_MARK = 'mark',
  TYPE_CHECK_MARK = 'checkMark'
}

interface PostActionWrapperProps {
  typeOfMark: MARK_TYPE
  datetime: string
  actionType: ACTION_TYPE | null
  bottomLine?: boolean
}

const PostActionWrapper: FC<PostActionWrapperProps> = ({
  typeOfMark,
  datetime,
  children,
  actionType,
  bottomLine
}) => (
  <div className='post-action'>
    {actionType === ACTION_TYPE.TYPE_ANSWER_PUSHED ||
    actionType === ACTION_TYPE.TYPE_QUESTION_PUSHED ? (
      <div className='post-action_left-border'>
        <div className='post-action_left-border-top'></div>
        <div className='post-action_left-border-center'></div>
        {bottomLine && <div className='post-action_left-border-bottom'></div>}
        <img className='post-action_left-border-circle' src={CircleChatHistoryIcon} alt='' />
      </div>
    ) : (
      <div className='post-action_left-border'>
        {typeOfMark === MARK_TYPE.TYPE_MARK && <div className='post-action_left-border-mark'></div>}
        {typeOfMark === MARK_TYPE.TYPE_CHECK_MARK && (
          <div className='post-action_left-border-check-mark'>
            <img className='post-action_left-border-check-mark-img' src={CheckMark} alt='' />
          </div>
        )}
        <div className='post-action_left-border-line'></div>
      </div>
    )}

    <div className='post-action_content'>
      <div className='post-action_content-datetime'>
        {!datetime
          ? `Today, ${format(new Date(), 'hh:mm bbb')}` // TODO remove this line when backend will be fixed
          : isToday(parseISO(datetime))
          ? `Today, ${format(parseISO(datetime), 'hh:mm bbb')}`
          : format(parseISO(datetime), 'dd-MMM-yyyy, hh:mm bbb')}
      </div>
      {children}
    </div>
  </div>
)

export default PostActionWrapper
